import type { BoxProps } from '@mui/material/Box'
import type { SxProps, Theme } from '@mui/material/styles'

type VehiclePictureStyleMap = {
    root: SxProps<Theme>
}

export const vehiclePictureStyles: VehiclePictureStyleMap = {
    root: { width: '100%' },
}

export const getVehiclePictureImageStyles = (imgSx?: BoxProps['sx']): SxProps<Theme> => ({
    width: '100%',
    height: 'auto',
    display: 'block',
    ...(imgSx as object ?? {}),
})
